import { z } from 'zod';
/**
 * E6 — Operação e Plantão (RF-29 a RF-31).
 *
 * O Plantão cobre a rua com reservas. Precisa de três coisas (PRD, seção 5):
 * janela em contagem, operador habilitado na tecnologia do carro, e previsão
 * de retorno confiável — que chega sozinha, sem telefone (RN-16).
 */
export const ReplacementDemandStatus = {
    OPEN: 'OPEN',
    ASSIGNED: 'ASSIGNED',
    MET: 'MET',
    MISSED: 'MISSED',
    CANCELLED: 'CANCELLED',
};
export const DEMAND_STATUS_LABELS = {
    OPEN: 'Aberta',
    ASSIGNED: 'Reserva designada',
    MET: 'Janela atendida',
    MISSED: 'Janela estourada',
    CANCELLED: 'Cancelada',
};
/**
 * Janela padrão para cobrir uma linha, em minutos.
 * ARBITRADO: o PRD registra os valores de SLA como questão aberta (seção 12).
 */
export const DEFAULT_REPLACEMENT_WINDOW_MINUTES = 40;
export const createDemandSchema = z.object({
    lineCode: z.string().trim().min(1, 'Informe a linha').max(16),
    /** Carro que saiu da linha e precisa de reposição, quando houver. */
    originVehicleId: z.string().uuid().optional(),
    windowMinutes: z.coerce.number().int().min(5).max(240).default(DEFAULT_REPLACEMENT_WINDOW_MINUTES),
    note: z.string().trim().max(255).optional(),
});
/** RF-30 — a reserva só aceita operador habilitado na tecnologia do carro. */
export const assignReserveSchema = z.object({
    vehicleId: z.string().uuid('Selecione o carro reserva'),
    operatorId: z.string().uuid('Selecione o operador'),
});
export const demandQuerySchema = z.object({
    status: z.nativeEnum(ReplacementDemandStatus).optional(),
    /** Só o que ainda está em aberto ou com reserva na rua. */
    active: z.coerce.boolean().default(true),
});
/** Função do operador nas bases da Operação. */
export const OperatorFunction = {
    MOTORISTA: 'MOTORISTA',
    COBRADOR: 'COBRADOR',
};
export const OPERATOR_FUNCTION_LABELS = {
    MOTORISTA: 'Motorista',
    COBRADOR: 'Cobrador',
};
//# sourceMappingURL=operations.schemas.js.map